module.exports = __webpack_public_path__ + "img/imgs15.0f800bc7.png";